import React from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';

import { Nav, NavLink } from '~/shared-components';
import { campaignTab } from '~/routes';
import Tag from '@bufferapp/ui/Tag';
import { selectCampaignCounts } from '~/campaign/selectors';
import { CampaignTab } from '~/campaign/types';

type Props = { campaignId: string };

export const NavItems = ({ campaignId }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { sent, scheduled, draftsCount, approvalsCount } = useSelector(
    selectCampaignCounts,
    shallowEqual
  );

  return (
    <Nav>
      <NavLink
        testId="scheduled-tab"
        to={campaignTab.getRoute({ campaignId, tab: CampaignTab.Scheduled })}
      >
        {t('campaigns.viewCampaign.scheduledTitle')}
        <Tag color="grayLight" textColor="grayDark">
          {scheduled}
        </Tag>
      </NavLink>
      <NavLink
        testId="sent-tab"
        to={campaignTab.getRoute({ campaignId, tab: CampaignTab.Sent })}
      >
        {t('campaigns.viewCampaign.sentTitle')}
        <Tag color="grayLight" textColor="grayDark">
          {sent}
        </Tag>
      </NavLink>
      <NavLink
        testId="drafts-tab"
        to={campaignTab.getRoute({
          campaignId,
          tab: CampaignTab.Drafts,
        })}
      >
        {t('campaigns.viewCampaign.draftsTitle')}
        <Tag color="grayLight" textColor="grayDark">
          {draftsCount}
        </Tag>
      </NavLink>
      <NavLink
        testId="approvals-tab"
        to={campaignTab.getRoute({
          campaignId,
          tab: CampaignTab.Approvals,
        })}
      >
        {t('campaigns.viewCampaign.approvalsTitle')}
        <Tag color="grayLight" textColor="grayDark">
          {approvalsCount}
        </Tag>
      </NavLink>
    </Nav>
  );
};
